import React from 'react'
import { slugs } from '@/constants/slugs'
import { getProjectStyle, createContactSupportAnswer } from '../shared'
import { GiveawayFaq } from '../types'

export const getTruthAndTreasonFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('giveawayHowDoIenter', 'How do I enter The Angel Giveaway?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'TnTReleaseDateAnswers',
          'Just pre-order tickets to Truth and Treason, in theaters October 17. Each ticket you buy is an entry—and\n' +
            'the more tickets you buy, the more your entries multiply. Buy early for even bigger multipliers. Both\n' +
            'ways boost your chances to win!',
        )}
      </span>
    ),
  },
  {
    key: 'doIneedTickets',
    question: (t) => t('doINeedTicketsQuestion', 'Do I need to buy tickets to enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'doINeedTicketsAnswer',
          'No. While buying tickets is the easiest way to enter, you can also enter by mail without purchase. See the Official Rules for instructions on free entry options.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhoCanEnter', 'Who can enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorWhoCanEnterAnswer',
          'The giveaway is open to legal residents of the 50 United States (excluding NY and FL) and the\n' +
            'District of Columbia, who are at least the age of majority in their state at the time of entry.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhenDoesItEnd', 'When does the giveaway end?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'TnTWhenDoesItEndAnswer',
          'Entries are open from August 25, 2025, through October 31, 2025, at 11:59 PM PT. Winners will be selected shortly after and notified via the contact information provided at entry.',
        )}
      </span>
    ),
  },
  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.senior),
  },
]
